// Заголовок вкладки и описание страницы для поисковиков и превью в мессенджерах.
// Вызывается на каждой странице: usePageMeta({ title, description }).

import { useEffect } from "react";

const SITE_NAME = "Kazakh Japan";

const setMeta = (selector, attr, value) => {
  if (!value) return;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    const [key, val] = selector.replace(/^meta\[|\]$/g, "").split("=");
    tag.setAttribute(key, val.replace(/"/g, ""));
    document.head.appendChild(tag);
  }
  tag.setAttribute(attr, value);
};

export const setPageMeta = ({ title, description }) => {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : SITE_NAME;
  document.title = fullTitle;

  setMeta('meta[name="description"]', "content", description);
  setMeta('meta[property="og:title"]', "content", fullTitle);
  setMeta('meta[property="og:description"]', "content", description);
  setMeta('meta[property="og:url"]', "content", window.location.href);
  setMeta('meta[name="twitter:title"]', "content", fullTitle);
  setMeta('meta[name="twitter:description"]', "content", description);
};

export const usePageMeta = ({ title, description }) => {
  useEffect(() => {
    setPageMeta({ title, description });
  }, [title, description]);
};

export default usePageMeta;
